// src/lib/windgram/bandConfig.js

// Skysight ta(): given an ascending [{value,rgb}] scale and which sentinels exist,
// returns { labels, thresholds } for d3-contour. Verbatim from bundle line 753-764.
export function bandConfig(scale, { hasLowerSentinel, hasUpperSentinel }) {
  const s = scale.slice(hasLowerSentinel ? 1 : 0, -1); // drop lower sentinel + always-last
  if (s.length === 0) return { labels: [], thresholds: [] };
  return {
    labels: s,
    thresholds: [
      hasLowerSentinel ? scale[0].value : s[0].value,
      ...s.slice(0, -1).map((band, i) => (band.value + s[i + 1].value) / 2),
    ],
  };
}

// getCenteredBandConfig: cldfra has no lower sentinel, everything else has both.
export function centeredBandConfig(variable, scale) {
  return variable === 'cldfra'
    ? bandConfig(scale, { hasLowerSentinel: false, hasUpperSentinel: true })
    : bandConfig(scale, { hasLowerSentinel: true, hasUpperSentinel: true });
}

// getFillColor: find the band [value, nextValue) containing the contour value.
// Verbatim from bundle line 1949-1959.
export function getFillColor(contour, bands) {
  const hit = bands.filter((band, i) =>
    i === bands.length - 1
      ? contour.value > bands[i].value
      : contour.value >= bands[i].value && contour.value < bands[i + 1].value,
  );
  return hit.length === 1 ? `rgb(${hit[0].rgb.join(',')})` : 'rgb(0,0,0)';
}
